let amaModulesCache: any = null;


export default function getModules() {
  if (amaModulesCache) return amaModulesCache;

  amaModulesCache = {
    prebidScript: 'https://micro.rubiconproject.com/prebid/dynamic/15518.js',
    useLimitedAds: true,
    useSeenthis: true,
    useLoadDMByAdsLib: true,
    useGLazyLoad: ['responsive_1', 'top_ad'],
    usePlacementCheck: true,
    useStats: true,
    useVideoStats: true,
    adTags: {},
    adnScript: 'https://cdn.adnuntius.com/adn.js',
  };
  return amaModulesCache;
}
